/**
   * 字符串中是否含有中文
   */
function isChinese(str: string) {
  const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
  if (reg.test(str)) {
    return true;
  }
  return false;
}

/**
 * 统计非中文的字符串中的字符长度
 */
export function nonChineseCharactersLength(str: (string)) {
  let len = 0;
  if (!isChinese(str)) {
    len = str.length;
  }
  return len;
}
